/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../model/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "stockorders": {
        "nested": {
          "message": {
            "nested": {
              "ListTransferOrderLinesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ListTransferOrderLinesResponse": {
                "fields": {
                  "transferOrderLine": {
                    "type": "squareup.stockorders.model.TransferOrderLine",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchTransferOrderLinesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "query": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesFilter",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "sortOrder": {
                    "type": "squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "pageSize": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TransferOrderLinesFilter": {
                    "fields": {
                      "filterType": {
                        "type": "squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesFilter.FilterType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "filterValues": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "FilterType": {
                        "values": {
                          "TRANSFER_ORDER_LINES_FILTER_DO_NOT_USE": 0,
                          "ITEM_NAME": 1,
                          "VARIATION_NAME": 2,
                          "SKU": 3,
                          "VENDOR_CODE": 4
                        }
                      }
                    }
                  },
                  "TransferOrderLinesSort": {
                    "fields": {
                      "sortType": {
                        "type": "squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortOrder",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SortType": {
                        "values": {
                          "SORT_TYPE_DO_NOT_USE": 0,
                          "NUMBER_PENDING": 1,
                          "ITEM_NAME": 2,
                          "SKU": 3,
                          "VENDOR_CODE": 4
                        }
                      },
                      "SortOrder": {
                        "values": {
                          "SORT_ORDER_DO_NOT_USE": 0,
                          "ASC": 1,
                          "DSC": 2
                        }
                      }
                    }
                  }
                }
              },
              "SearchTransferOrderLinesResponse": {
                "fields": {
                  "transferOrderLine": {
                    "type": "squareup.stockorders.model.TransferOrderLine",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.ListTransferOrderLinesRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.ListTransferOrderLinesResponse && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest?.nested?.TransferOrderLinesFilter && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest?.nested?.TransferOrderLinesFilter?.nested?.FilterType && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest?.nested?.TransferOrderLinesSort && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest?.nested?.TransferOrderLinesSort?.nested?.SortType && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesRequest?.nested?.TransferOrderLinesSort?.nested?.SortOrder && !$root.nested?.squareup?.nested?.stockorders?.nested?.message?.nested?.SearchTransferOrderLinesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListTransferOrderLinesRequest @ squareup/stockorders/message/transfer_order_lines.proto at 10:1
 */
export const ListTransferOrderLinesRequest = $root.lookupType('squareup.stockorders.message.ListTransferOrderLinesRequest');
fixType(ListTransferOrderLinesRequest);
Builder.createAndAttachToType(ListTransferOrderLinesRequest);
/**
 * SOURCE ListTransferOrderLinesResponse @ squareup/stockorders/message/transfer_order_lines.proto at 16:1
 */
export const ListTransferOrderLinesResponse = $root.lookupType('squareup.stockorders.message.ListTransferOrderLinesResponse');
fixType(ListTransferOrderLinesResponse);
Builder.createAndAttachToType(ListTransferOrderLinesResponse);
/**
 * SOURCE SearchTransferOrderLinesRequest @ squareup/stockorders/message/transfer_order_lines.proto at 22:1
 */
export const SearchTransferOrderLinesRequest = $root.lookupType('squareup.stockorders.message.SearchTransferOrderLinesRequest');
fixType(SearchTransferOrderLinesRequest);
Builder.createAndAttachToType(SearchTransferOrderLinesRequest);
/**
 * SOURCE TransferOrderLinesFilter @ squareup/stockorders/message/transfer_order_lines.proto at 29:3
 */
SearchTransferOrderLinesRequest.TransferOrderLinesFilter = $root.lookupType('squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesFilter');
fixType(SearchTransferOrderLinesRequest.TransferOrderLinesFilter);
Builder.createAndAttachToType(SearchTransferOrderLinesRequest.TransferOrderLinesFilter);
/**
 * SOURCE FilterType @ squareup/stockorders/message/transfer_order_lines.proto at 30:5
 */
SearchTransferOrderLinesRequest.TransferOrderLinesFilter.FilterType = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesFilter.FilterType').values;
/**
 * SOURCE TransferOrderLinesSort @ squareup/stockorders/message/transfer_order_lines.proto at 43:3
 */
SearchTransferOrderLinesRequest.TransferOrderLinesSort = $root.lookupType('squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort');
fixType(SearchTransferOrderLinesRequest.TransferOrderLinesSort);
Builder.createAndAttachToType(SearchTransferOrderLinesRequest.TransferOrderLinesSort);
/**
 * SOURCE SortType @ squareup/stockorders/message/transfer_order_lines.proto at 44:5
 */
SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortType = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortType').values;
/**
 * SOURCE SortOrder @ squareup/stockorders/message/transfer_order_lines.proto at 54:5
 */
SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortOrder = $root.lookupEnum('squareup.stockorders.message.SearchTransferOrderLinesRequest.TransferOrderLinesSort.SortOrder').values;
/**
 * SOURCE SearchTransferOrderLinesResponse @ squareup/stockorders/message/transfer_order_lines.proto at 68:1
 */
export const SearchTransferOrderLinesResponse = $root.lookupType('squareup.stockorders.message.SearchTransferOrderLinesResponse');
fixType(SearchTransferOrderLinesResponse);
Builder.createAndAttachToType(SearchTransferOrderLinesResponse);